import api from '@/api';

export function listPortalPurchaseOrders() {
  return api.get('/dashboard/customer/purchase-orders');
}

/**
 * @param {File}file
 * @param {string} [reference]
 */
export function uploadPortalPurchaseOrder(file, reference) {
  const fd = new FormData();
  fd.append('file', file);
  if (reference != null && String(reference).trim() !== '') {
    fd.append('reference', String(reference).trim());
  }
  return api.post('/dashboard/customer/purchase-orders', fd, {
    transformRequest: [
      (data, headers) => {
        if (data instanceof FormData) {
          delete headers['Content-Type'];
        }
        return data;
      },
    ],
  });
}

/** API returns array or { purchase_orders } */
export function normalizePortalPurchaseOrdersList(payload) {
  if (Array.isArray(payload)) return payload;
  if (payload && typeof payload === 'object' && Array.isArray(payload.purchase_orders)) return payload.purchase_orders;
  if (payload && typeof payload === 'object' && Array.isArray(payload.data)) return payload.data;
  return [];
}

export function listAdminPurchaseOrders() {
  return api.get('/admin/purchase-orders');
}

/** Download PO file (authenticated blob). */
export async function downloadAdminPurchaseOrderFile(poId, fallbackFileName) {
  const { data, headers } = await api.get(`/admin/purchase-orders/${poId}/file`, { responseType: 'blob' });
  let name = fallbackFileName || 'purchase-order';
  const cd = headers['content-disposition'];
  if (cd) {
    const m = /filename\*?=(?:UTF-8'')?([^;\n]+)/i.exec(cd);
    if (m) {
      name = decodeURIComponent(m[1].replace(/['"]/g, '').trim());
    }
  }
  const url = URL.createObjectURL(data);
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
